import {createContext, useContext, useMemo} from "react";

import {useGisMapContext} from "../GisMapContext";
import {useDrawEndButton} from "../../Map/Draw/DrawEndButton/DrawEndButtonContext";
import {drawEndButtonState} from "../../Map/Draw/DrawEndButton/DrawEndButtonState";
import {DrawTools, drawState} from "../../Map/Draw/DrawState";
import {useDrawV2} from "../../Map/Draw/DrawV2Context";

const DrawContext = createContext();

const toTools = ({polygon, circle, point, uploadFile}) => {
  const tools = [];

  if (polygon) {
    tools.push(DrawTools.POLYGON);
  }

  if (circle) {
    tools.push(DrawTools.CIRCLE);
  }

  if (point) {
    tools.push(DrawTools.POINT);
  }

  if (uploadFile) {
    tools.push(DrawTools.UPLOAD_FILE);
  }

  return tools;
};

export function useDraw() {
  const drawV2 = useDrawV2();
  const drawEndButton = useDrawEndButton();
  const gisMap = useGisMapContext();

  return useMemo(() => {
    return {
      map: gisMap.map,
      draw: {current: drawState.draw},
      drawing: {current: drawV2.isDrawing},
      initDraw: () => undefined,
      startDrawing: ({onCreate, onUpdate, onDelete, ...legacyTools}) => {
        drawV2.startDrawing({
          tools: toTools(legacyTools),
          onCreate,
          onUpdate,
          onDelete,
        });
      },
      startDrawingSilent: () => undefined,
      endDrawing: drawV2.endDrawing,
      isDrawing: {
        isDrawing: drawV2.isDrawing,
        polygon: drawV2.polygon,
        circle: drawV2.circle,
        point: drawV2.point,
        uploadFile: drawV2.file,
      },
      endButton: {
        show: drawEndButton.isShowing,
        title: drawEndButtonState.getTitle(),
        buttonText: drawEndButtonState.getButtonText(),
      },
      showEndButton: drawEndButton.show,
      hideEndButton: drawEndButton.hide,
      endButtonEventEmitter: drawEndButton.emit,
      callOnCreateCallback: drawV2.forceCallback,
      deleteLayer: drawV2.deleteLayer,
      deleteAllLayers: drawV2.deleteAllLayers,
    };
  }, [drawEndButton, drawV2, gisMap.map]);
}

export const DrawConsumer = DrawContext.Consumer;

export function DrawProvider({children}) {
  return children;
}
